import chartLineUpIcon from '../assets/images/marketsnav/ChartLineUp (1).svg';
import chartPieSliceIcon from '../assets/images/marketsnav/ChartPieSlice.svg';
import coinsIcon from '../assets/images/marketsnav/Coins.svg';
import chartBarIcon from '../assets/images/marketsnav/ChartBar.svg';
import cubeIcon from '../assets/images/marketsnav/Cube.svg';
import equitiesHero from '../assets/images/markets/equities/equities.svg';
import etfsHero from '../assets/images/markets/etfs/etfs.svg';
import forexHero from '../assets/images/markets/forex/forex.svg';
import indicesHero from '../assets/images/markets/indicies/indicies.svg';
import commoditiesHero from '../assets/images/markets/comodities/comodities.svg';
import chartDonutIcon from '../assets/images/markets/other/marketsegments/ChartDonut.svg';
import swapSegmentIcon from '../assets/images/markets/other/marketsegments/Swap.svg';
import presentationChartIcon from '../assets/images/markets/other/marketsegments/PresentationChart.svg';
import compassIcon from '../assets/images/markets/other/marketsegments/Compass.svg';
import appleLogo from '../assets/images/markets/other/featuredcompanies/apple.svg';
import microsoftLogo from '../assets/images/markets/other/featuredcompanies/microsoft.svg';
import amazonLogo from '../assets/images/markets/other/featuredcompanies/amazon.svg';
import googleLogo from '../assets/images/markets/other/featuredcompanies/google.svg';
import teslaLogo from '../assets/images/markets/other/featuredcompanies/tesla.svg';
import nvidiaLogo from '../assets/images/markets/other/featuredcompanies/nvidia.svg';

const accessItems = [
  'Deep liquidity pools',
  'Competitive spreads',
  'Fast execution',
];

const featuredCompanies = [
  {
    name: 'Apple Inc. (AAPL)',
    category: 'Technology & Consumer Electronics',
    text: 'Global leader in consumer technology, driven by a powerful ecosystem of hardware, software, and services with unmatched brand loyalty.',
    logo: appleLogo,
  },
  {
    name: 'Microsoft Corp. (MSFT)',
    category: 'Technology & Consumer Electronics',
    text: 'A cornerstone of the global enterprise landscape, leading in software, cloud productivity, and cutting-edge artificial intelligence integration.',
    logo: microsoftLogo,
  },
  {
    name: 'Amazon.com Inc. (AMZN)',
    category: 'Technology & Consumer Electronics',
    text: 'Dominant force in global retail and the pioneer of cloud infrastructure through AWS, focused on long-term operational efficiency.',
    logo: amazonLogo,
  },
  {
    name: 'Alphabet Inc. (GOOGL)',
    category: 'Technology & Consumer Electronics',
    text: 'Parent company of Google and YouTube, maintaining a dominant share in global search infrastructure and digital advertising markets.',
    logo: googleLogo,
  },
  {
    name: 'Tesla Inc. (TSLA)',
    category: 'Technology & Consumer Electronics',
    text: 'The global leader in electric mobility and sustainable energy solutions, focused on autonomous driving technology and energy storage.',
    logo: teslaLogo,
  },
  {
    name: 'NVIDIA Corp. (NVDA)',
    category: 'Technology & Consumer Electronics',
    text: 'The primary engine of the AI revolution, providing high-performance computing power for the next generation of technology.',
    logo: nvidiaLogo,
  },
];

export const markets = [
  {
    slug: 'equities',
    category: 'Markets',
    title: 'Equities',
    subtitle: 'Tesla, Apple, Amazon, Netflix',
    heroDescription:
      'Trade leading public companies across sectors, regions, and growth stages with institutional access and execution.',
    cta: 'Open an Account',
    icon: chartLineUpIcon,
    heroImage: equitiesHero,
    companiesTitle: 'Invest in Global Companies.',
    companiesParagraphs: [
      'Equities represent ownership in publicly traded companies, offering investors the opportunity to participate in long-term growth and value creation.',
      'From established blue-chip corporations to high-growth technology firms, equity markets provide access to a diverse range of investment opportunities across global economies.',
    ],
    segmentsTitle: 'Equity Market Segments',
    segments: [
      {
        title: 'Blue-Chip Stocks',
        text: 'Large, established companies with strong financial performance and long-term stability.',
        icon: chartDonutIcon,
      },
      {
        title: 'Growth Stocks',
        text: 'High-growth companies focused on innovation and expansion, often in technology and emerging sectors.',
        icon: swapSegmentIcon,
      },
      {
        title: 'Dividend Stocks',
        text: 'Companies that provide consistent income through regular dividend distributions.',
        icon: presentationChartIcon,
      },
      {
        title: 'Emerging Markets',
        text: 'Exposure to fast-growing economies with higher risk and return potential.',
        icon: compassIcon,
      },
    ],
    featuredCompanies,
    accessTitle: 'Institutional Market Access',
    accessText:
      'VBS provides access to global equity markets through institutional-grade execution infrastructure, ensuring efficient pricing, deep liquidity, and reliable order handling.',
    accessItems,
    accessCta: 'Become a Client',
    riskText:
      'Equity investments are subject to market volatility and economic conditions. Prices may fluctuate, and past performance does not guarantee future results.',
  },
  {
    slug: 'etfs',
    category: 'Markets',
    title: 'ETFs',
    subtitle: 'iShares, Vanguard, Lyxor, Amundi',
    heroDescription:
      'Access global equity markets and invest in leading public companies across sectors, regions, and growth stages.',
    cta: 'Open an Account',
    icon: chartPieSliceIcon,
    heroImage: etfsHero,
    companiesTitle: 'Invest Across Global Markets.',
    companiesParagraphs: [
      'ETFs provide a single allocation into baskets of listed companies, giving investors diversified exposure without selecting each name individually.',
      'From region and sector funds to thematic strategies, ETF markets open a wide range of opportunities across global economies.',
    ],
    segmentsTitle: 'ETF Market Segments',
    segments: [
      {
        title: 'Equity ETFs',
        text: 'Broad or focused baskets of listed companies across regions, sectors, and market capitalisations.',
        icon: chartDonutIcon,
      },
      {
        title: 'Thematic ETFs',
        text: 'Strategies built around innovation themes, from technology to energy transition and healthcare.',
        icon: swapSegmentIcon,
      },
      {
        title: 'Income ETFs',
        text: 'Funds structured to deliver regular distributions from dividends or underlying yield.',
        icon: presentationChartIcon,
      },
      {
        title: 'Regional ETFs',
        text: 'Exposure to developed and emerging markets through a single, transparent allocation.',
        icon: compassIcon,
      },
    ],
    featuredCompanies,
    accessTitle: 'Institutional Market Access',
    accessText:
      'VBS provides access to global equity markets through institutional-grade execution infrastructure, ensuring efficient pricing, deep liquidity, and reliable order handling.',
    accessItems,
    accessCta: 'Become a Client',
    riskText:
      'ETF investments are subject to market volatility and economic conditions. Prices may fluctuate, and past performance does not guarantee future results.',
  },
  {
    slug: 'forex',
    category: 'Markets',
    title: 'Forex',
    subtitle: 'EUR/USD, GBP/USD, CHF/JPY',
    heroDescription:
      'Access the world’s most liquid currency pairs with precise execution across major, minor, and cross-market flows.',
    cta: 'Open an Account',
    icon: coinsIcon,
    heroImage: forexHero,
    companiesTitle: 'Trade Global Currencies.',
    companiesParagraphs: [
      'Forex markets let you participate in the world’s most liquid asset class, moving between major, minor, and cross pairs with institutional execution.',
      'From EUR/USD to emerging-market crosses, currency markets provide access to global capital flows around the clock.',
    ],
    segmentsTitle: 'Forex Market Segments',
    segments: [
      {
        title: 'Major Pairs',
        text: 'The most liquid currency pairs, including EUR/USD, GBP/USD, and USD/JPY.',
        icon: chartDonutIcon,
      },
      {
        title: 'Minor Pairs',
        text: 'Crosses that exclude the US dollar while remaining actively traded across global sessions.',
        icon: swapSegmentIcon,
      },
      {
        title: 'Cross Pairs',
        text: 'Regional currency combinations used to express views without a dollar overlay.',
        icon: presentationChartIcon,
      },
      {
        title: 'Emerging Markets',
        text: 'Higher-volatility currencies tied to growth economies and shifting capital flows.',
        icon: compassIcon,
      },
    ],
    featuredCompanies,
    accessTitle: 'Institutional Market Access',
    accessText:
      'VBS provides access to global equity markets through institutional-grade execution infrastructure, ensuring efficient pricing, deep liquidity, and reliable order handling.',
    accessItems,
    accessCta: 'Become a Client',
    riskText:
      'Currency trading is subject to market volatility and economic conditions. Prices may fluctuate, and past performance does not guarantee future results.',
  },
  {
    slug: 'indices',
    category: 'Markets',
    title: 'Indices',
    subtitle: 'S&P 500, DAX, UK100, NIKKEI',
    heroDescription:
      'Trade major global indices in a single view — from the S&P 500 and DAX to the UK100 and Nikkei.',
    cta: 'Open an Account',
    icon: chartBarIcon,
    heroImage: indicesHero,
    companiesTitle: 'Access Global Benchmarks.',
    companiesParagraphs: [
      'Indices concentrate the performance of leading listed companies into a single market view, from the S&P 500 and DAX to the UK100 and Nikkei.',
      'They offer a clear way to participate in regional and global equity trends without building a full stock-by-stock book.',
    ],
    segmentsTitle: 'Index Market Segments',
    segments: [
      {
        title: 'US Indices',
        text: 'Benchmarks such as the S&P 500 that concentrate leading US listed companies.',
        icon: chartDonutIcon,
      },
      {
        title: 'European Indices',
        text: 'Regional gauges including the DAX and UK100 for continental and UK market exposure.',
        icon: swapSegmentIcon,
      },
      {
        title: 'Asia-Pacific Indices',
        text: 'Benchmarks such as the Nikkei that track major listed companies across the region.',
        icon: presentationChartIcon,
      },
      {
        title: 'Global Indices',
        text: 'Broader measures designed to follow multi-region equity performance in a single view.',
        icon: compassIcon,
      },
    ],
    featuredCompanies,
    accessTitle: 'Institutional Market Access',
    accessText:
      'VBS provides access to global equity markets through institutional-grade execution infrastructure, ensuring efficient pricing, deep liquidity, and reliable order handling.',
    accessItems,
    accessCta: 'Become a Client',
    riskText:
      'Index investments are subject to market volatility and economic conditions. Prices may fluctuate, and past performance does not guarantee future results.',
  },
  {
    slug: 'commodities',
    category: 'Markets',
    title: 'Commodities',
    subtitle: 'Gold, Oil, Gas, Coffee',
    heroDescription:
      'Access gold, energy, and agricultural markets through a single institutional platform built for clarity and control.',
    cta: 'Open an Account',
    icon: cubeIcon,
    heroImage: commoditiesHero,
    companiesTitle: 'Invest in Real Assets.',
    companiesParagraphs: [
      'Commodities provide exposure to gold, energy, and agricultural markets, offering a distinct path alongside equities and currencies.',
      'From precious metals to oil, gas, and coffee, these markets connect portfolios to physical supply, demand, and global trade.',
    ],
    segmentsTitle: 'Commodity Market Segments',
    segments: [
      {
        title: 'Precious Metals',
        text: 'Gold and related metals used for diversification and long-term store-of-value exposure.',
        icon: chartDonutIcon,
      },
      {
        title: 'Energy',
        text: 'Oil and gas markets tied to global demand, supply, and industrial activity.',
        icon: swapSegmentIcon,
      },
      {
        title: 'Agriculture',
        text: 'Soft commodities such as coffee that reflect harvest cycles and trade flows.',
        icon: presentationChartIcon,
      },
      {
        title: 'Industrial Metals',
        text: 'Materials linked to construction, manufacturing, and broader economic growth.',
        icon: compassIcon,
      },
    ],
    featuredCompanies,
    accessTitle: 'Institutional Market Access',
    accessText:
      'VBS provides access to global equity markets through institutional-grade execution infrastructure, ensuring efficient pricing, deep liquidity, and reliable order handling.',
    accessItems,
    accessCta: 'Become a Client',
    riskText:
      'Commodity investments are subject to market volatility and economic conditions. Prices may fluctuate, and past performance does not guarantee future results.',
  },
];

export const getMarketBySlug = (slug) =>
  markets.find((market) => market.slug === slug);
